import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FooterPublic } from '../_UI/Footer/Public/FooterPublic';
import { ScrollToTopButton } from '../../../../Web/_UI/ScrollToTopButton';
import { HeaderPrivate } from '../_UI/Header/Private/HeaderPrivate';
import { userHasAccess } from '../../../HELPERS/_moduleFactory.helper';
import { SidebarPrivate } from '../_UI/Sidebar/Private/SidebarPrivate';
import { useSectionTitle } from '../../Hooks/Hooks/useSectionMetaTitle';
import { AppHeaderUtilities } from '../_UI/Header/_Utilities/AppHeaderUtilities';
import { BannerModeDevelopment } from '../../../_Config/UI/BannerModeDevelopment';
import { APP_SHELL_MENU, onResolveShellNav } from '../../../_Config/AppShell.Layout';
import { useLanguage } from '../../Hooks/Contexts/Translate/useLanguageContext';

export const AppLayoutPrivate = ({ isAuth = true, user = null, onClickLogout = null, outletContext = {} }) => {

    const [useIsAsideOpen, setIsAsideOpen] = useState(false);

    const { pathname } = useLocation();

    const { useDataLanguage } = useLanguage();

    // El contexto de autenticacion conserva metadata de sesion en el nivel superior
    // y los datos del usuario en .data. El sidebar sigue recibiendo el estado completo;
    // el dropdown de perfil recibe solamente la identidad real.
    const HEADER_USER = user?.data ?? user;
    const IS_AUTHENTICATED = user?.isAuthenticated ?? isAuth;

    const SHELL_NAV = onResolveShellNav(user, useDataLanguage.currentLang);

    const BRAND = { ...APP_SHELL_MENU.brand, claim: SHELL_NAV.claim };

    const SIDEBAR_NAV = SHELL_NAV.privateNav.filter((item) => item.displayInSidebar !== false && userHasAccess(user, item)).map((item) => (Array.isArray(item.children) && item.children.length > 0 ? {
        ...item, children: item.children.filter((child) => (
            child.displayInSidebar !== false && userHasAccess(user, child)
        )),
    } : item));

    useSectionTitle(SHELL_NAV.privateRoutes, APP_SHELL_MENU.brand.name);

    const onCloseAside = () => setIsAsideOpen(false);

    return (
        <div className="LStudio__app_shell LStudio__app_shell--private">
            <SidebarPrivate key={pathname} brand={BRAND} navItems={SIDEBAR_NAV}
                groupLabel={SHELL_NAV.sidebarGroup} isOpen={useIsAsideOpen} onClose={onCloseAside} />

            <div className="LStudio__app_shell__column">

                <HeaderPrivate onToggleAside={() => setIsAsideOpen(true)} utilities={
                    <AppHeaderUtilities isAuth={IS_AUTHENTICATED} user={HEADER_USER}
                        onClickLogout={onClickLogout} profileLinks={SHELL_NAV.profileLinks}
                        languages={APP_SHELL_MENU.languages} data={{}} />} />

                <BannerModeDevelopment />

                <main className="LStudio__app_shell__main">
                    <div className="LStudio__app_shell__inner">
                        <Outlet context={outletContext} />
                    </div>

                    <ScrollToTopButton />

                </main>

                <FooterPublic isPrivate brand={BRAND} columns={SHELL_NAV.footerColumnsPrivate}
                    legal={SHELL_NAV.legal} showBrandLS={APP_SHELL_MENU.showBrandLS} />

            </div>
        </div>
    );
};
